(() => {
  // Product has no Judge.me reviews: show the store-wide rating (labelled "across our store"),
  // or a plain "0 reviews" summary when the store has none either.
  function paintStars(box, avg) {
    box.querySelectorAll('.jdgm-star').forEach((star, i) => {
      const fill = avg - i;
      star.classList.remove('jdgm--on', 'jdgm--off', 'jdgm--half');
      star.classList.add(fill >= 0.75 ? 'jdgm--on' : fill >= 0.25 ? 'jdgm--half' : 'jdgm--off');
    });
  }

  function mount(root) {
    if (root.dataset.emptyReviewReady) return;
    root.dataset.emptyReviewReady = 'true';
    const storeCount = Number(root.dataset.storeCount || 0);
    const storeAvg = Number(root.dataset.storeAvg || 0);
    const hist = (root.dataset.storeHist || '').split(',').filter(Boolean).map(Number);
    const useStore = storeCount > 0;

    function update() {
      root.querySelectorAll('.jdgm-rev-widg').forEach(widget => {
        if (!widget.hasAttribute('data-number-of-reviews')) return;
        if (Number(widget.getAttribute('data-number-of-reviews')) !== 0) {
          widget.querySelectorAll('[data-kpt-empty-average]').forEach(el => el.remove());
          widget.classList.remove('kpt-store-rating');
          return;
        }
        const stars = widget.querySelector('.jdgm-rev-widg__summary-stars');
        const summary = widget.querySelector('.jdgm-rev-widg__summary-text');
        const averageText = useStore ? root.dataset.storeAverage : root.dataset.emptyReviewAverage;
        const summaryText = useStore ? root.dataset.storeSummary : root.dataset.emptyReviewSummary;
        if (stars) {
          let average = stars.querySelector('[data-kpt-empty-average]');
          if (!average) {
            average = document.createElement('span');
            average.dataset.kptEmptyAverage = '';
            average.className = 'jdgm-rev-widg__summary-average';
            stars.append(average);
          }
          if (average.textContent !== averageText) average.textContent = averageText;
          if (useStore) { paintStars(stars, storeAvg); stars.setAttribute('aria-label', averageText); }
        }
        if (summary && summary.textContent !== summaryText) summary.textContent = summaryText;
        if (useStore && hist.length === 5 && !widget.classList.contains('kpt-store-rating')) {
          widget.classList.add('kpt-store-rating');
          widget.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(row => {
            const r = Number(row.getAttribute('data-rating'));
            if (!(r >= 1 && r <= 5)) return;
            const n = hist[5 - r], pct = Math.round((n / storeCount) * 100);
            const bar = row.querySelector('.jdgm-histogram__bar-content');
            if (bar) bar.style.width = pct + '%';
            const p = row.querySelector('.jdgm-histogram__percentage');
            if (p) p.textContent = pct + '%';
            const f = row.querySelector('.jdgm-histogram__frequency');
            if (f) f.textContent = String(n);
          });
        }
      });
    }
    update();
    const observer = new MutationObserver(update);
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews']});
    root.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
  }
  document.querySelectorAll('[data-empty-review-summary]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-empty-review-summary]').forEach(mount));
})();
